import { createLucideIcon } from 'lucide-preact';

// Iconos de marca que lucide eliminó en la 1.0 (retiró todos los logotipos
// de marcas). Se conservan aquí con el mismo trazo que tenían en
// lucide-preact 0.469 (licencia ISC), construidos con `createLucideIcon` para
// que acepten las mismas props (`size`, `strokeWidth`, `class`...) que el resto
// de iconos y se puedan pasar a `Icon`, `Button.leftIcon`, etc. sin instalar
// otro pack de iconos.

export const FacebookIcon = createLucideIcon('Facebook', [
  [
    'path',
    { d: 'M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z', key: '1jg4f8' },
  ],
]);

export const ChromeIcon = createLucideIcon('Chrome', [
  ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
  ['circle', { cx: '12', cy: '12', r: '4', key: '4exip2' }],
  ['line', { x1: '21.17', x2: '12', y1: '8', y2: '8', key: 'a0cw5f' }],
  ['line', { x1: '3.95', x2: '8.54', y1: '6.06', y2: '14', key: '1kftof' }],
  ['line', { x1: '10.88', x2: '15.46', y1: '21.94', y2: '14', key: '1ymyh8' }],
]);
